import React from 'react';
import Devices, { defaultConfigComponent as DeviceConfig } from './Devices';
import { IConfigComponent } from '@ts/ui-models';

export const defaultConfigComponent = (): IConfigComponent => {
  return {
    ...DeviceConfig(),
    componentId: 'devicesIssued',
    filtersFetchData: {
      device: { isAlive: true },
      deviceType: { isAlive: true },
      deviceTypeCategories: { isAlive: true },
      category: { isAlive: true, logicalId: 'physical' },
      status: 'attached',
    },
  };
};
const DevicesIssued = props => {
  const defaultProps = {
    title: 'Issued devices',
  };

  return <Devices configComponent={defaultConfigComponent()} {...defaultProps} {...props} />;
};

export default DevicesIssued;

/*   const _getColumns = () => {
    return [
      {
        fnLabel: () => `${this.props.t('ID')}`,
        name: 'id',
        fHidden: true,
      },
      {
        fnLabel: () => `${this.props.t('Tracker')}`,
        name: 'tracker',
        rawValue: o => {
          return o.get('name');
        },
        render: (o, name) => {
          let id = o.get('logicalId');
          return (
            <span>
              <span>{name}</span>
              <br />
              <Link href={`/device/${id}/view`} style={{ color: 'gray', fontSize: 10, whiteSpace: 'nowrap' }}>
                {h.getDisplayId(o)}
              </Link>
            </span>
          );
        },
      },
      {
        fnLabel: () => `${this.props.t('Attached to')}`,
        name: 'attached',
        rawValue: o => {
          let item = o.getIn(['element', 'pxee', 0, 'parentElement', 'asset', 'name']);
          if (!item) return;
          return item;
        },
      },
    ];
  }; */
